import { useState, useEffect } from 'react';
import { fetchBillingGroupDrop, voucher, voucherList } from "./addVoucherService";
import { errorToast, successToast } from '../../../components/toastmessage/toastmessage';
import { useLocation, useNavigate } from "react-router-dom";
import { handleVoucherValidation } from './validation';

function useAddVouchereHook(initialState) {
    let location = useLocation();
    let navigate = useNavigate()

    const [BillingGroup, setBillingGroupState] = useState([]);
    const [voucherState, setVoucherState] = useState(initialState);
    const [errors, setError] = useState({});

    const fetchBillingGroup = async () => {
        try {
            let result = await fetchBillingGroupDrop();
            if (result.status === 200) setBillingGroupState(result?.data?.result);
        } catch (e) {
            return e
        }

    }
    useEffect(() => {
        fetchBillingGroup();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setVoucherState((prevFormState) => ({
            ...prevFormState,
            [name]: value
        }));
    }


    const allowNumbersOnly = (e) => {
        var code = (e.which) ? e.which : e.keyCode;
        if (code > 31 && (code < 48 || code > 57)) {
            e.preventDefault();
        }
    }

    const handleSubmitVoucher = async (e, fromState) => {
        e.preventDefault();
        let payload = {
            ...fromState,
            patientID: location?.state?.rowData?.patientID,
            ipdid: location?.state?.rowData?.ipdid,
            activeStatus: true,
            createdBy: "system",
            modifiedBy: "system"
        }
        const isValid = await handleVoucherValidation(payload);
        if (isValid?.isValid) {
            try {
                await voucher(payload);
                await voucherList(location?.state?.rowData?.ipdid)
                successToast("Successfully Inserted");
                setVoucherState({})
            } catch (err) {
                errorToast(err?.response?.data?.message)
            }

        } else {
            setError(isValid?.errors)
        }


    }
    const handleBlur = async () => {
        const newErrors = await handleVoucherValidation(voucherState);
        let inputError = {
            ...newErrors?.errors,
            formIsValid: newErrors?.formIsValid,
            basicInfoError: newErrors?.individualInputErrors
        };
        setError(inputError)

    };
    const handleGoBack = () => {
        navigate("/ipd")

    }
    return {
        BillingGroup,
        setBillingGroupState,
        handleChange,
        setVoucherState,
        voucherState,
        handleSubmitVoucher,
        allowNumbersOnly,
        errors,
        handleBlur,
        handleGoBack

    };
}

export default useAddVouchereHook;
